import React, { Component } from "react";
import "./Graph.scss";
import { apiURL } from '../Services/Base';

const isNumeric = n => parseFloat(n) == n;
const PollAuthorList = [
    {
        value: 1,
        name: "11",
        ordering: 1
    },
    {
        value: 2,
        name: "12",
        ordering: 1
    },
    {
        value: 3,
        name: "13",
        ordering: 1
    },
    {
        value: 4,
        name: "14",
        ordering: 1
    },
    {
        value: 5,
        name: "ידיעות אחרונות",
        ordering: 0
    }
];

export default class Graph extends Component {
    constructor() {
        super();
        this.state = {
            isAnimated: false,
            disclaimerTxt: ""
        }
    }
    componentDidMount() {
        this.getDisclaimer();
      }
    componentDidUpdate() {
        var timer = window.setTimeout(() => {
            window.clearTimeout(timer);
            if (this.container && !this.state.isAnimated) {
                let index = 0;
                this.setState({
                    isAnimated: true
                })
                this.container.childNodes.forEach(obj => {
                    if (obj.nodeName == "DIV") {
                        if (obj.className.indexOf("active") > -1) {
                            obj.classList.remove("active");
                        }
                        window.setTimeout(() => {
                            obj.classList.add("active");
                        }, 50 * index)
                        index++;
                    }
                });
            }
        }, 60);
    }
    getDisclaimer = () => {
        fetch(`${apiURL}GetDisclaimerTextById/2`, {
            headers:{
            "Content-Type": "application/json"
        },
        method: "POST"
        
          }).then(response => response.json()).then(data => {
            this.setState({
                disclaimerTxt: data.Disclaimer
            });
          }).catch(e => console.log(e));
        }
    render() {
        return (
            <div>
                <section className="section section-graph">
                    <div className="padding">
                        <div className={`container ${this.state.isAnimated ? " isAnimated" : ""} ${this.props.activeButton == 0 ? "" : "datelist"}`} ref={container => this.container = container}>
                            {this.props.list.length == 0 ? "אין נתונים." : ""}
                            {(() => this.props.list.sort((a, b) => {
                                if (a.Times > 1 || b.Times > 1) {
                                    return Math.round(b.Mandat / b.Times) - Math.round(a.Mandat / a.Times)
                                }
                                if (this.props.activeButton == 0) {
                                    return b.Mandat - a.Mandat;
                                } else {
                                    return new Date(b.ordering).getTime() - new Date(a.ordering).getTime();
                                }
                            }).map((item, index) => {
                                let mandat = item.Times > 1 ? Math.round(item.Mandat / item.Times) : item.Mandat;
                                let date = item.date ? item.date.split("-") : "";
                                if (item.Miflaga == "") {
                                    return (<div></div>)
                                }
                                return (
                                    <div className="miflaga" key={index}>
                                        <div className="details">
                                            <div className="name">{isNumeric(item.Miflaga) ? PollAuthorList.filter(k => k.value == item.Miflaga)[0].name : item.Miflaga}</div>
                                            {item.date ? <div className="date">{date[2]}.{date[1]}</div> : ""}
                                        </div>
                                        <div className="graph">
                                            <div className="overlay"></div>
                                            <div className="bar monly" style={{ width: `${(mandat <= 0 ? 1 : mandat) * 90 / 45}%` }}></div>
                                            <div className="bar donly" style={{ height: `${(mandat <= 0 ? 1 : mandat) * 90 / 45}%` }}></div>
                                            <div className={`score ${mandat < 4 ? " red" : ""}`}>{mandat}</div>
                                        </div>
                                    </div>)
                            }))()}

                        </div>
                    </div>
                </section>
                {this.props.dates.length == 0 && this.props.activeButton == 0 ?
                    <div className="comment">{this.state.disclaimerTxt}</div> : ""}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/Components/Graph/Graph.jsx